import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title fw-bolder" }
const _hoisted_4 = { class: "card-toolbar" }
const _hoisted_5 = { class: "svg-icon svg-icon-2" }
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = {
  key: 0,
  class: "d-flex justify-content-center mt-15 mb-15"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border spinner-lg",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  class: "modal fade show",
  id: "kt_modal_event_info",
  "aria-modal": "true",
  role: "dialog",
  ref: "newTargetModalRef"
}
const _hoisted_11 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_12 = { class: "modal-content" }
const _hoisted_13 = { class: "modal-header" }
const _hoisted_14 = { class: "fw-bolder" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = {
  class: "btn btn-icon btn-sm btn-active-icon-primary",
  id: "kt_modal_event_info_close",
  "data-bs-dismiss": "modal"
}
const _hoisted_17 = { class: "svg-icon svg-icon-1" }
const _hoisted_18 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_19 = { class: "row mb-7" }
const _hoisted_20 = { class: "col-lg-4 fw-bold text-muted" }
const _hoisted_21 = { class: "col-lg-8" }
const _hoisted_22 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_23 = { class: "row mb-7" }
const _hoisted_24 = { class: "col-lg-4 fw-bold text-muted" }
const _hoisted_25 = { class: "col-lg-8" }
const _hoisted_26 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_27 = { class: "row mb-7" }
const _hoisted_28 = { class: "col-lg-4 fw-bold text-muted" }
const _hoisted_29 = { class: "col-lg-8" }
const _hoisted_30 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_31 = { class: "row mb-7" }
const _hoisted_32 = { class: "col-lg-4 fw-bold text-muted" }
const _hoisted_33 = { class: "col-lg-8" }
const _hoisted_34 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_35 = {
  key: 0,
  class: "row mb-7"
}
const _hoisted_36 = { class: "col-lg-4 fw-bold text-muted" }
const _hoisted_37 = { class: "row mb-3 mt-5" }
const _hoisted_38 = ["innerHTML"]
const _hoisted_39 = { class: "modal-footer flex-center" }
const _hoisted_40 = {
  "data-bs-dismiss": "modal",
  type: "reset",
  id: "kt_modal_event_info_cancel",
  class: "btn btn-light me-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_FullCalendar = _resolveComponent("FullCalendar")!
  const _component_CreateMeetingModal = _resolveComponent("CreateMeetingModal")!
  const _component_EditMeetingModal = _resolveComponent("EditMeetingModal")!
  const _component_InfoMeetingModal = _resolveComponent("InfoMeetingModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.t('meeting.calendar')), 1),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "btn btn-flex btn-primary",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addMeeting && _ctx.addMeeting(...args)))
          }, [
            _createElementVNode("span", _hoisted_5, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr075.svg" })
            ]),
            _createTextVNode(" " + _toDisplayString(_ctx.t('meeting.addMeeting')), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_ctx.calendarLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
          : (_openBlock(), _createBlock(_component_FullCalendar, {
              key: 1,
              ref: "calendar",
              class: "demo-app-calendar",
              options: _ctx.calendarOptions
            }, null, 8, ["options"]))
      ])
    ]),
    _createVNode(_component_CreateMeetingModal, {
      date: _ctx.selectedDate,
      onMeetingCreate: _ctx.onMeetingCreate
    }, null, 8, ["date", "onMeetingCreate"]),
    _createVNode(_component_EditMeetingModal, {
      id: _ctx.selectedMeeting,
      onMeetingEdit: _ctx.onMeetingEdited
    }, null, 8, ["id", "onMeetingEdit"]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("h2", _hoisted_14, [
              (_ctx.selectedEvent.type != 'other')
                ? (_openBlock(), _createElementBlock("span", _hoisted_15, " (" + _toDisplayString(_ctx.$t('calendar.' + _ctx.selectedEvent.type)) + ") ", 1))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(_ctx.selectedEvent.title), 1)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("span", _hoisted_17, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr061.svg" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.t('calendar.title')) + " :", 1),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.selectedEvent.title), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.t('calendar.startDate')) + " :", 1),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.moment(_ctx.selectedEvent.start).format('DD/MM/YYYY, H:mm')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.t('calendar.endDate')) + " :", 1),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.moment(_ctx.selectedEvent.end).format('DD/MM/YYYY, H:mm')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.t('calendar.target')) + " :", 1),
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("span", _hoisted_34, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedEvent.target, (target) => {
                    return (_openBlock(), _createElementBlock("span", {
                      class: "badge-light badge fs-8 me-1 ms-1 fw-bolderms-1",
                      key: target
                    }, _toDisplayString(_ctx.t('calendar.' + target)), 1))
                  }), 128))
                ])
              ])
            ]),
            (_ctx.selectedEvent.desc)
              ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                  _createElementVNode("label", _hoisted_36, _toDisplayString(_ctx.t('course.description')) + " :", 1),
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("div", {
                      innerHTML: _ctx.selectedEvent.desc
                    }, null, 8, _hoisted_38)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("button", _hoisted_40, _toDisplayString(_ctx.t('student.close')), 1)
          ])
        ])
      ])
    ], 512),
    _createVNode(_component_InfoMeetingModal, {
      id: _ctx.selectedMeeting,
      onEditMeeting: _ctx.onEditMeeting,
      onDeleteMeeting: _ctx.onDeleteMeeting
    }, null, 8, ["id", "onEditMeeting", "onDeleteMeeting"])
  ], 64))
}